import React from 'react';
import PageHero from '../components/common/PageHero';
import About from '../components/home/AboutUs';
import OurTeam from '../components/home/OurTeam';

const AboutUs = () => {
  return (
    <div>
      <PageHero
        title="About Infinity Enterprises"
        subtitle="Governance, vision, and people behind our maritime and logistics operations."
      />
      <About />
      <OurTeam />
    </div>
  );
};

export default AboutUs;